// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O_TN","index":"styles_index__1vtjK"};